import { useWatch } from 'react-hook-form';

import { Show } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { dateUtils } from 'shared_DEPRECATED/utils';

import {
  SessionSidebarFieldset,
  SessionSidebarFieldsetLabel,
} from 'features/sessions/components';
import { SessionsFormActualEndTimeSelector } from 'features/sessions/components/Form/SessionInfo/ActualEndTimeSelector';
import { SessionsFormActualStartTimeSelector } from 'features/sessions/components/Form/SessionInfo/ActualStartTimeSelector';
import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import { getTimeLabel } from 'features/sessions/utils';

import { Badge } from 'shared/components/Badge';
import { Typography } from 'shared/components/Typography';

export const SessionsActualTimeSelector = () => {
  const [sessionStartDate, sessionEndDate, attendance] = useWatch({
    name: ['startedAt', 'endedAt', 'attendance'],
  });

  const isActualTimeVisible = [
    SESSION_ATTENDANCE_STATUS.ATTENDED,
    SESSION_ATTENDANCE_STATUS.RESCHEDULED,
    SESSION_ATTENDANCE_STATUS.SCHEDULED,
  ].includes(attendance);

  return (
    <Show when={isActualTimeVisible}>
      <SessionSidebarFieldset>
        <Flex width="100%" justifyContent="space-between">
          <SessionSidebarFieldsetLabel>
            Actual session time
          </SessionSidebarFieldsetLabel>
          <Badge colorPalette="lightGray">
            <Typography
              color="black"
              type="small"
              dataTestid="left-sidebar-actual-time-duration-badge"
            >
              {getTimeLabel(
                dateUtils.localDate(sessionStartDate).toISOString(),
                dateUtils.localDate(sessionEndDate).toISOString()
              )}
            </Typography>
          </Badge>
        </Flex>
        <Flex>
          <SessionsFormActualStartTimeSelector />
          <Spacer size="zr md">
            <Typography type="meta" color="gray">
              -
            </Typography>
          </Spacer>
          <SessionsFormActualEndTimeSelector />
        </Flex>
      </SessionSidebarFieldset>
    </Show>
  );
};
